<template>
    <div class="row p-3" v-if="graphic_layout">
        <!-- lista foto -->
        <div class="col-md-4" v-for="product in this.products">
            <div class="item d-flex flex-row flex-md-column">
                <div class="col-5 col-md-12 px-0">
                    <router-link
                        :to="{name:'menu.category.product',params:{id:product.id,category_id:getCategoryId(product)}}">
                        <img :src="getProductImage(product.foto_codice)" class="img-fluid img-center">
                    </router-link>
                    <div class="quantita-carrello" v-if="getTotalPerProduct(product.id)">
                        {{ getTotalPerProduct(product.id) }}
                    </div>
                </div>
                <div class="dati d-flex flex-column pl-2 pl-sm-0 p-sm-2">
                    <div class="text-left mb-sm-2">
                        <router-link
                            :to="{name:'menu.category.product',params:{id:product.id,category_id:getCategoryId(product)}}"
                            class="a1">
                          <b>{{ product.nome }}</b>
                        </router-link>
                        <inc-product-price-label :currency="locale_currency" :product="product"
                                                 :graphic-layout="graphic_layout"/>
                    </div>
                    <!-- <p class="ingredienti-foto truncate-2">
                         <span v-if="f_deliverect">
                           {{ product.descrizione }}
                        </span>
                        <span v-else v-for="(ingredient, i) in product.ingredienti"
                              :class="{'font-weight-bold': ingredient.allergeni}">
                            {{ ingredient.alias }} {{ parseInt(i) === (product.ingredienti.length - 1) ? "" : ", " }}
                        </span>
                    </p>-->
                    <button class="btn btn-outline d-flex justify-content-start align-items-center p-0 mb-0 f11 color"
                            @click="$router.push({name:'menu.category.product',params:{id:product.id,category_id:getCategoryId(product)}})">
                      <span class="material-symbols-outlined mr-1">shopping_cart</span> {{ $t('aggiungi') }}
                    </button>
                </div>

            </div>
        </div>
    </div>
    <!-- fine lista foto -->

    <!-- lista no foto -->
    <div class="row" v-else>
        <div class="col-12 border-bottom" v-for="product in this.products">
            <div class="item mb-0 p-3">
                <div class="dati">
                    <p class="nome">
                        <router-link
                            :to="{name:'menu.category.product',params:{id:product.id,category_id:getCategoryId(product)}}"
                            class="a3">
                            {{ product.nome }}
                        </router-link>
                    </p>

                    <div class="d-flex justify-content-between align-items-center prodotti-nofoto">
                        <div class="d-flex align-items-center flex-grow-1">
                          <inc-product-price-label :product="product" :currency="locale_currency"
                                                   :graphic-layout="graphic_layout"/>
                        </div>
                        <button class="btn btn-outline d-flex justify-content-start align-items-center p-0 mb-0 f11 color piu"
                                @click="$router.push({name:'menu.category.product',params:{id:product.id,category_id:getCategoryId(product)}})">
                          <span class="material-symbols-outlined mr-1">shopping_cart</span> {{ $t('aggiungi') }}
                        </button>
                    </div>

                </div>
            </div>
        </div>
        <!-- fine no foto -->
    </div><!-- /.row -->
</template>

<script>
import {mapGetters, mapState} from 'vuex';

import IncProductPriceLabel from './IncProductPriceLabel';

import {getImage} from '../../../api/core';

export default {
    name: "IncProductSuggestedList",
    components: {IncProductPriceLabel},
    props: ['products', 'categoryId'],
    computed: {
        ...mapState('restaurant', {
            id_ristorante: state => state.id,
            f_deliverect: state => state.f_deliverect
        }),
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapGetters('restaurant', {
            graphic_layout: 'graphicLayout',
            locale_currency: 'localeCurrency'
        }),
        ...mapState('order', {
            order: state => state
        })
    },
    methods: {
        getTotalPerProduct: function (id) {
            let total = 0;

            this.order.items.forEach((item) => {
                if (item.item.id === id) {
                    total += item.quantity;
                }
            });

            return total;
        },
        getProductImage: function (code) {
            return getImage(this.language, this.id_ristorante, code);
        },
        getCategoryId: function (product) {
            if (this.categoryId) {
                return this.categoryId;
            }

            try {
                return product.categorie[0].id;
            } catch (e) {
                return 0;
            }
        }
    }
}
</script>
